import axios from 'axios';

import { SearchRequest } from 'core/util/Search';

export enum FieldName {
    CountryId = '__country_id__',
    Name = '__region_name__',
}

export interface Region {
    id: string;
    code: string;
    countryID: string;
    name: string;
    type: string;
    bingID: string;
}

export const getRegions = async (
    agencyId: number,
    tenantId: number,
    search: SearchRequest,
    args?: any,
): Promise<Region[]> => {
    const params: any = { agencyId, tenantId, search, args };

    const { data } = await axios.get('/api/regions', { params });

    return data;
};
